var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261157347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78782 14.8419C11.1606 12.9368 14.0765 11.6808 15.5355 11.0739C19.7011 9.3413 20.5667 9.04032 21.1309 9.03038C21.255 9.02819 21.5324 9.05895 21.7122 9.20477C21.8639 9.32791 21.9057 9.49425 21.9256 9.61099C21.9456 9.72774 21.9705 9.99369 21.9507 10.2015C21.725 12.5733 20.7482 18.3292 20.2513 20.9857C20.041 22.1098 19.627 22.4867 19.2262 22.5236C18.3551 22.6037 17.6937 21.9479 16.85 21.3949C15.5298 20.5295 14.7839 19.9907 13.5025 19.1463C12.0215 18.1703 12.9816 17.6339 13.8256 16.7573C14.0464 16.5279 17.8844 13.037 17.9587 12.7203C17.968 12.6807 17.9766 12.533 17.8889 12.4551C17.8012 12.3771 17.6718 12.4038 17.5783 12.425C17.4459 12.455 15.3369 13.849 11.2513 16.607C10.6526 17.018 10.1104 17.2183 9.62456 17.2078C9.08899 17.1962 8.05875 16.905 7.29288 16.656C6.3535 16.3507 5.6069 16.1892 5.67192 15.6707C5.70578 15.4005 6.07775 15.1243 6.78782 14.8419Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegramLogo.113ced3f580d2479116d671d1ce02814.svg";
export { ForwardRef as ReactComponent };